<script setup>
import { onMounted, onUnmounted, ref, computed } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { enGB, ru } from "date-fns/locale";

const store = useStore();
const route = useRoute();
const { locale } = useI18n();

const languages = ref({ eu: enGB, ru });
const group = computed(() => store.state.group || { shares: [] });

async function fetchGroup() {
    const groupID = route.params.group;
    if (groupID) {
        await store.dispatch("fetchGroup", { group: groupID });
    }
}

let intervalId;
onMounted(() => {
    fetchGroup();
    intervalId = setInterval(fetchGroup, 10000);
});
onUnmounted(() => clearInterval(intervalId));
</script>


<template>
    <div class="miners">
        <h3 class="mb-2">{{group.groupID}}</h3>
        <v-table density="comfortable" class="border rounded">
            <thead>
                <tr>
                    <th>{{ $t("miner") }}</th>
                    <th>{{ $t("shares_round_sum") }}</th>
                    <th>{{ $t("your_round_share") }}</th>
                </tr>
            </thead>
            <tbody v-if="group.shares.length > 0">
                <tr v-for="(item, index) in group.shares" :key="index">
                    <td>
                        <router-link class="text-monospace" :to="'/account/' + item.miner">
                            {{ item.miner }}
                        </router-link>
                    </td>
                    <td>
                        <span v-html="$filters.difficulty(item.shares, 2)"></span>
                    </td>
                    <td>
                        {{ $filters.round(item.percent, 6) }}
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="3" class="text-center">{{ $t("no_data") }}</td>
                </tr>
            </tbody>
        </v-table>
    </div>
</template>
